<template>
    <loader v-if="loading || $store.getters['quality/teams'].length < 2" />
    <div v-else>
        <v-row v-if="department === 'alka'">
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="departmentUnrealizedChart.options" :series="departmentUnrealizedChart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="departmentCanceledChart.options" :series="departmentCanceledChart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="departmentAdjustedChart.options" :series="departmentAdjustedChart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="department === 'alka'">
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="teamUnrealizedChart.options" :series="teamUnrealizedChart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="teamCanceledChart.options" :series="teamCanceledChart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="teamAdjustedChart.options" :series="teamAdjustedChart.series" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
    },
    data () {
        return {
            loading: true,
            colors: ['#546E7A', '#F5B041', '#FF0000', '#00CCCC', '#FF33FC', '#E91E63', '#FF9800'],
            targetColors: ['#2E93fA', '#66DA26'],
            departmentUnrealizedChart: {
                options: {
                    title: {
                        text: 'Annulleringsprocent total afdelingen'
                    },
                    chart: {
                        animations: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.percentageDecimal
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: this.$options.filters.percentageDecimal
                    }
                },
                series: []
            },
            departmentCanceledChart: {
                options: {
                    title: {
                        text: 'Annulleringsprocent nysalg afdelingen'
                    },
                    chart: {
                        animations: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.percentageDecimal
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: this.$options.filters.percentageDecimal
                    }
                },
                series: []
            },
            departmentAdjustedChart: {
                options: {
                    title: {
                        text: 'Annulleringsprocent nedsættelser afdelingen'
                    },
                    chart: {
                        animations: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.percentageDecimal
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: this.$options.filters.percentageDecimal
                    }
                },
                series: []
            },
            teamUnrealizedChart: {
                options: {
                    title: {
                        text: 'Annulleringsprocent total ÅTD pr. team'
                    },
                    stroke: {
                        width: [5, 3, 3]
                    },
                    chart: {
                        animations: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.percentageDecimal
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    dataLabels: {
                        enabled: true,
                        enabledOnSeries: [],
                        formatter: this.$options.filters.percentageDecimal
                    }
                },
                series: []
            },
            teamCanceledChart: {
                options: {
                    title: {
                        text: 'Annulleringsprocent nysalg ÅTD pr. team'
                    },
                    stroke: {
                        width: [5, 3, 3]
                    },
                    chart: {
                        animations: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.percentageDecimal
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    dataLabels: {
                        enabled: true,
                        enabledOnSeries: [],
                        formatter: this.$options.filters.percentageDecimal
                    }
                },
                series: []
            },
            teamAdjustedChart: {
                options: {
                    title: {
                        text: 'Annulleringsprocent nedsættelser ÅTD pr. team'
                    },
                    stroke: {
                        width: [5, 3, 3]
                    },
                    chart: {
                        animations: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            formatter: this.$options.filters.percentageDecimal
                        },
                        max: max => (max || (1 / 1.1)) * 1.1
                    },
                    dataLabels: {
                        enabled: true,
                        enabledOnSeries: [],
                        formatter: this.$options.filters.percentageDecimal
                    }
                },
                series: []
            }
        }
    },
    computed: {
        year () {
            return this.$store.state.quality.year
        },
        department () {
            return this.$store.getters['quality/department']
        },
        teams () {
            return this.$store.getters['quality/teams']
        }
    },
    methods: {
        async getData() {
            this.loading = true
            this.setTeamCanceledChartOptions()
            const response = await this.$http().get('/quality/development/cancelations', {
                params: {
                    year: this.year,
                    department: this.department
                }
            })
            this.departmentUnrealizedChart.series = response.data.totalUnrealizedSeries
            this.teamUnrealizedChart.series = response.data.teamUnrealizedSeries
            this.departmentCanceledChart.series = response.data.totalCanceledSeries
            this.teamCanceledChart.series = response.data.teamCanceledSeries
            this.departmentAdjustedChart.series = response.data.totalAdjustedSeries
            this.teamAdjustedChart.series = response.data.teamAdjustedSeries
            this.loading = false
        },
        setTeamCanceledChartOptions() {
            this.teamUnrealizedChart.options.dataLabels.enabledOnSeries = Array.from(new Array(this.$store.getters['quality/teams'].length - 1), (x, i) => i)
            this.teamUnrealizedChart.options.colors = [...this.colors.slice(0, this.$store.getters['quality/teams'].length - 1), ...this.targetColors]
            this.teamUnrealizedChart.options.stroke.width = [...Array.from(new Array(this.$store.getters['quality/teams'].length - 1), () => 5), 2, 2]
            this.teamCanceledChart.options.dataLabels.enabledOnSeries = Array.from(new Array(this.$store.getters['quality/teams'].length - 1), (x, i) => i)
            this.teamCanceledChart.options.colors = [...this.colors.slice(0, this.$store.getters['quality/teams'].length - 1), ...this.targetColors]
            this.teamCanceledChart.options.stroke.width = [...Array.from(new Array(this.$store.getters['quality/teams'].length - 1), () => 5), 2, 2]
            this.teamAdjustedChart.options.dataLabels.enabledOnSeries = Array.from(new Array(this.$store.getters['quality/teams'].length - 1), (x, i) => i)
            this.teamAdjustedChart.options.colors = [...this.colors.slice(0, this.$store.getters['quality/teams'].length - 1), ...this.targetColors]
            this.teamAdjustedChart.options.stroke.width = [...Array.from(new Array(this.$store.getters['quality/teams'].length - 1), () => 5), 2, 2]
        }
    },
    watch: {
        year: function () {
            this.getData()
        },
        department: function () {
            this.getData()
        },
        teams: function () {
            this.setTeamCanceledChartOptions()
        }
    },
    created () {
        this.getData()
    }
}
</script>